<template>
    <div class="content">
        <div class="content-full">
            <div id="login-placeholder" />
            <router-view v-if="pageDataLoaded" />
        </div>
    </div>
</template>

<script>
import checkChannel from '@/utils/checkChannel';

export default {
    name: 'App',
    data() {
        return {
            pageDataLoaded: false,
            context: {
                // 当前用户所拥有的套餐
                channelIds: [],
                isShowQQKfuin: true,
                isShowQQKfext: true,
                // SSC套餐
                isSsc: false,
            },
        };
    },
    provide() {
        return {
            context: this.context,
        };
    },
    async created() {
        window.pageData = window.pageData || {};

        await this.initBaseInfo();

        try {
            const baseInfo = await this.getBaseInfo();
            const { data = {} } = baseInfo || {};
            this.context.isSsc = !!data.isSsc;
            window.pageData.data = {
                ...(window.pageData.data || {}),
                isSsc: !!data.isSsc,
                isCommercial: data.isCommercial,
                corpInfo: data.corpInfo,
                noticPrivilege: data.noticPrivilege,
            };
            window.pageData.disableKfuin = !data.realNameAccount;
        } catch (error) {
            console.error('getBaseInfo获取数据失败', error);
        }

        this.pageDataLoaded = true;
    },
    mounted() {
        checkChannel.getChannelIds.call(this).then((channelIds) => {
            this.context.channelIds = channelIds;

            if (checkChannel.checkChannelNotInData([1, 2], channelIds)) {
                this.context.isShowQQKfuin = false;
                this.context.isShowQQKfext = false;
            } else {
                this.context.isShowQQKfuin = checkChannel.checkChannelInData([1], channelIds);
                this.context.isShowQQKfext = checkChannel.checkChannelInData([2], channelIds);
            }
        });
    },
    methods: {
        async initBaseInfo() {
            const waitForQDAdminCommon = (timeout = 10000) => new Promise((resolve, reject) => {
                const startTime = Date.now();
                const check = () => {
                    if (Date.now() - startTime > timeout) {
                        reject(new Error('等待QD_ADMIN_COMMON加载超时'));
                        return;
                    }

                    if (window.QD_ADMIN_COMMON) {
                        resolve(window.QD_ADMIN_COMMON);
                    } else {
                        setTimeout(check, 100);
                    }
                };

                check();
            });

            try {
                const QD_ADMIN_COMMON = await waitForQDAdminCommon();
                const { envConfig } = QD_ADMIN_COMMON;
                const { mode, isPrivate } = envConfig || {};

                window.pageData.env = isPrivate ? 'private' : mode;
            } catch (error) {
                console.error('初始化环境配置失败:', error);
                window.pageData.env = 'prod';
            }
        },

        async getBaseInfo() {
            const url = '/v1/kf/receptionConf/common/signs';
            try {
                const rs = await this.$ajax.gatewayGet(url);
                if (rs && !rs.code) {
                    return rs.data;
                }

                this.$message.error(rs.message || '获取数据失败');
            } catch (ex) {
                this.$message.error(ex.message || '获取数据失败');
            }
        },
    },
};
</script>

<style lang="less">
@import '~@/common/common';
</style>
